<section class="cst_body">

  <div class="container-fluid search_flt_box_main">
    <!-- need to write -->
    <form [formGroup]="searchForm" (ngSubmit)="search(searchForm)">
      <div class="search_flt_box">
      <div class="row">       

        <div class="col-2">
          <div class="form-group">
              <label for="formGroupExampleInput">Search By</label>
              <select id="inputState" class="form-control col-form-label-sm" formControlName="searchBy">
                <option [ngValue]="null" disabled>Select</option>
                <option>MRN</option>
                <option>Order ID</option>
                <option>Order Did</option>
              </select>        
          </div>
        </div>
        <div class="col-2">
            <div class="form-group">
              <label for="formGroupExampleInput">Enter Value</label>
              <input type="text" class="form-control col-form-label-sm" formControlName="searchByValue"
                placeholder="Enter Value">
            </div>
        </div>
          
                <div class="col-2">
                <div class="form-group">
                  <label>Status</label>
                  <select id="inputState" class="form-control col-form-label-sm" formControlName="status">
                    <option *ngFor="let data of refundStatusList" value={{data.value}}>{{data.name}}</option>
                  </select>
                </div>
              </div>
              
              
              <div class="col-4">
                <div class="form-group">
                  <label>Select Daterange:</label>
                  <div class="input-group">
                    <input class="form-control" #drp="bsDaterangepicker" bsDaterangepicker 
                    [bsValue]="bsRangeValue"
                    (bsValueChange)="onValueChange($event)" >
                    <div class="input-group-append">
                      <button class="btn btn-success" (click)="drp.toggle()" [attr.aria-expanded]="drp.isOpen" type="button"><i
                        class="fa fa-calendar" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>

              
              <div class="col-2 padLftRht6">
                <button type="submit" class="btn green_btn">Search</button>&nbsp;
                <button  class="btn green_btn" (click)="clear()">Clear</button>
              </div>
               

        </div>
      </div>
      <!-- need to close -->
    </form>
  </div>
  <div class="container-fluid" role="main" >
    <div class="table_main tableShadow">
      <!--<div class="tbl_name">
        All Orders <span class="fnt-medium">({{totalRecords}})</span>
      </div>-->
      <table class="table table-striped table-responsive">
        <thead>
          <tr class="tbl_name">
            <th>Type</th>
            <th>Order DID</th>
            <th>Check Receipsts</th>
            <th>MRN</th>
            <th>Amount</th>
            <th>Name</th>
            <th>Status</th>
            <th>Action</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let orderDetailsObj of orderDetailsRes;let i = index">

            <td>
              <span *ngIf="orderDetailsObj.action_level == 1">ORDER_LEVEL</span>
              <span *ngIf="orderDetailsObj.action_level != 1">ITEM_LEVEL</span>
            </td>
            <td>{{orderDetailsObj.odid}}</td>
            <td>
              <button  class="btn info_btn" (click)="refundOrder_recipts(orderDetailsObj.order_id)">Check Receipts</button>
            </td>
            <td>{{orderDetailsObj.mrn}}</td>
            <td>{{orderDetailsObj.amount}}</td>
            <td>{{orderDetailsObj.username}}</td>
            <td>
              <span *ngIf="orderDetailsObj.status == 1">INITIATED</span>
              <span *ngIf="orderDetailsObj.status == 2">PROCESSING</span>
              <span *ngIf="orderDetailsObj.status == 3">PROCESSED</span>
              <span *ngIf="orderDetailsObj.status == 4">REJECTED</span>
            </td> 
             
            <td class="view_btn" >
              <button  class="btn green_btn" (click)="update_refundOrderStatus(orderDetailsObj._id,orderDetailsObj.order_id,orderDetailsObj.odid,orderDetailsObj.transaction_code,orderDetailsObj.amount,orderDetailsObj.type,orderDetailsObj.reason,2)" *ngIf="orderDetailsObj.status == 1">Begin Processing</button>

              <button  class="btn green_btn" (click)="update_refundOrderStatus(orderDetailsObj._id,orderDetailsObj.order_id,orderDetailsObj.odid,orderDetailsObj.transaction_code,orderDetailsObj.amount,orderDetailsObj.type,orderDetailsObj.reason,3)" *ngIf="orderDetailsObj.status == 2">Complete Processing</button>

              <span *ngIf="orderDetailsObj.status != 1 && orderDetailsObj.status != 2">N/A</span>
            </td>
            <td>
              <button  class="btn danger_btn" (click)="update_refundOrderStatus(orderDetailsObj._id,orderDetailsObj.order_id,orderDetailsObj.odid,orderDetailsObj.transaction_code,orderDetailsObj.amount,orderDetailsObj.type,orderDetailsObj.reason,4)" *ngIf="orderDetailsObj.status == 1">Reject</button>
            </td>
            
          </tr>

        </tbody>
      </table>

    </div>
    <!--<div *ngIf="isOrderListDataExist"><b>No Records Found</b></div>
    <div class="col-12" *ngIf="orderDetailsRes?.length">

      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5" [boundaryLinks]="true"
        class="d-flex justify-content-end customPagination" (pageChange)="pageChange(page)">
      </ngb-pagination>

    </div>-->
    <div *ngIf="isOrderListDataExist" class="noRecord"><b>No Records Found</b></div>
    <div class="col-12 tableBottom" *ngIf="orderDetailsRes?.length">
      <div class="totalRecords">
        Total Orders <span class="fnt-medium">({{totalRecords}})</span>
      </div>
     <div>
      <ngb-pagination [collectionSize]="datacount" [(page)]="page" [pageSize]="pageSize" [maxSize]="5"
      [boundaryLinks]="true" class=" customPagination" (pageChange)="pageChange(page)">
      </ngb-pagination>
     </div> 
    </div>

  </div>
<!-- <div *ngIf="!isOrderListDataExist">No Records Found</div> -->
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>

  
</section>